<div class="SLV2-goalsttng-full no-header">

    <div class="SLV2-progress-bar-row" [ngClass]="{'show':mobileSliderStatus}">
       <div class="SLV2-progress-bar" [style.width.%]="goalStepProgress"></div>
    </div>
 
    <div class="SLV2-goalsttng-innr-wrap">
 
 
       <div class="SLV2-goalsttng-col left-col" [ngClass]="{'slider-collapsed':mobileSliderStatus}" *ngIf="!mobileSliderStatus">
 
          <div class="SLV2-slider-for-desk">
             <ng-container *ngTemplateOutlet="slider_1"></ng-container>
             <ng-container *ngTemplateOutlet="slider_2"></ng-container>
             <ng-container *ngTemplateOutlet="slider_3"></ng-container>
             <ng-container *ngTemplateOutlet="slider_4"></ng-container>
 
             <div class="SLV2-goalsttng-sld-bg">
                <img src="goal-setting-ui/assets/img/goal-setting/marketing-page-logo.svg" class="SLV2-gs-logo" />
                <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-bg-line-01.svg" class="SLV2-gs-line-bg" />
                <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-bg-line-02.svg" class="SLV2-gs-line-bg" />
             </div>
          </div>
 
          <ngb-carousel #carousel class="singleCarousel SLV2-goalsttng-lft-slider" [interval]="5000" [pauseOnHover]="pauseOnHover" [pauseOnFocus]="pauseOnFocus">       
             <ng-template ngbSlide>
                <ng-container *ngTemplateOutlet="slider_1"></ng-container>
             </ng-template>
             <!-- <ng-template ngbSlide>
                <ng-container *ngTemplateOutlet="slider_2"></ng-container>
             </ng-template> -->
             <ng-template ngbSlide>
                <ng-container *ngTemplateOutlet="slider_3"></ng-container>
             </ng-template>
             <ng-template ngbSlide>
                <ng-container *ngTemplateOutlet="slider_4"></ng-container>
             </ng-template>
          </ngb-carousel>
          <div class="SLV2-goalsttng-sld-mobile-btn-area">
             <button class="SLV2-submit-btn" (click)="mobileSlider()">
                <span>Set Your Goal</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16" fill="none"><path d="M24.7071 8.70711C25.0976 8.31658 25.0976 7.68342 24.7071 7.29289L18.3431 0.928932C17.9526 0.538408 17.3195 0.538408 16.9289 0.928932C16.5384 1.31946 16.5384 1.95262 16.9289 2.34315L22.5858 8L16.9289 13.6569C16.5384 14.0474 16.5384 14.6805 16.9289 15.0711C17.3195 15.4616 17.9526 15.4616 18.3431 15.0711L24.7071 8.70711ZM0 9H24V7H0V9Z" fill="#FCFCFC"/></svg>
             </button>
          </div>
 
       </div>
 
 
 
       <div class="SLV2-goalsttng-col right-col">
          <!-- {{goalStepProgress}} /  -->
          <!-- {{currentStep}} /prev {{previousStep}} -->
 
          <!-- step 1 open -->
          <div class="SLV2-goalsttng-step" [ngClass]="[currentStep == 1 ? 'active' : '', previousStep == 1 ? 'fixedtotop' : '']">
             <div class="SLV2-goalsttng-form-row grade">
                <div class="SLV2-goalsttng-form-hdng-row">
                   <h4 class="SLV2-goalsttng-form-hdng">I am in Grade</h4>
                   <h4 class="SLV2-goalsttng-form-subhdng">Single selection only</h4>
                </div>
 
                <div class="SLV2-goalsttng-form-field-row">
                   <ul class="SLV2-input-list">
                     <ng-container *ngFor="let grade of questionsData[0].data">
                        <li>
                           <label class="SLV2-customcheck-input"><input type="radio" name="grade"  (change)="onGradeSelect(grade)"/><span>{{grade.name}}</span></label>
                        </li>
                     </ng-container>
                   </ul>
                </div>
                <button class="SLV2-submit-btn" (click)="nextGoatStep()" [disabled]="!userSelectedGrade">
                   <span>OK</span>
                   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                      <path d="M6.55156 13.0001L0.851562 7.3001L2.27656 5.8751L6.55156 10.1501L15.7266 0.975098L17.1516 2.4001L6.55156 13.0001Z" fill="#FCFCFC"/>
                      </svg>
                </button>
             </div>
             <!-- <button class="SLV2-skip-text-button" (click)="nextGoatStep()">Skip this Step>></button> -->
          </div>
          <!-- step 1 closed -->
 
          <!-- step 2 open -->
          <div class="SLV2-goalsttng-step" [ngClass]="[currentStep == 2 ? 'active' : '', previousStep == 2 || ((userSelectedGrade?.name=='9th' || userSelectedGrade?.name=='10th') && currentStep == 5)  ? 'fixedtotop' : '']">
             <div class="SLV2-goalsttng-form-row exam">
                <div class="SLV2-goalsttng-form-hdng-row">
                   <h4 class="SLV2-goalsttng-form-hdng">{{userSelectedGrade?.name=="9th" || userSelectedGrade?.name=="10th" ? 'My target exam is': 'Exam'}}</h4>
                   <h4 class="SLV2-goalsttng-form-subhdng">Single selection only</h4>
                </div>
 
                <div class="SLV2-goalsttng-form-field-row">
                   <ul class="SLV2-input-list">
                     <ng-container *ngFor="let exam of questionsData[1].data">
                        <li>
                           <label class="SLV2-customcheck-input"><input type="radio" name="exam" (change)="onExamSelect(exam)"  [checked]="userSelectedExam?.name==exam?.name ?  true : false"/><span>{{exam.name}}</span></label>
                        </li>
                     </ng-container>
                   </ul>
                </div>
                <button class="SLV2-submit-btn" (click)="nextGoatStep()" [disabled]="!userSelectedExam" >
                   <span>OK</span>
                   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                      <path d="M6.55156 13.0001L0.851562 7.3001L2.27656 5.8751L6.55156 10.1501L15.7266 0.975098L17.1516 2.4001L6.55156 13.0001Z" fill="#FCFCFC"/>
                      </svg>
                </button>
             </div>
             <!-- <button class="SLV2-skip-text-button" (click)="nextGoatStep()">Skip this Step>></button> -->
          </div>
          <!-- step 2 closed -->
 
          <!-- step 3 open -->
          <div class="SLV2-goalsttng-step" [ngClass]="[currentStep == 3 ? 'active' : '', previousStep == 3 ? 'fixedtotop' : '']">
             <div class="SLV2-goalsttng-form-row aiming">
                <div class="SLV2-goalsttng-form-hdng-row">
                   <h4 class="SLV2-goalsttng-form-hdng">I am aiming for</h4>
                   <h4 class="SLV2-goalsttng-form-subhdng">Single selection only</h4>
                </div>
 
                <div class="SLV2-goalsttng-form-field-row">
                   <ul class="SLV2-input-list">
                     <ng-container *ngFor="let aim of questionsData[2].data ">
                        <li>
                           <label class="SLV2-customcheck-input"><input type="radio" name="aiming" (change)="onAimSelect(aim)"/><span>{{aim.aim}}</span></label>
                        </li>
                     </ng-container>
                   </ul>
                </div>
                <button class="SLV2-submit-btn" (click)="nextGoatStep()" [disabled]="!userSelectedAim">
                   <span>OK</span>
                   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                      <path d="M6.55156 13.0001L0.851562 7.3001L2.27656 5.8751L6.55156 10.1501L15.7266 0.975098L17.1516 2.4001L6.55156 13.0001Z" fill="#FCFCFC"/>
                      </svg>
                </button>
             </div>
             <!-- <button class="SLV2-skip-text-button" (click)="nextGoatStep()">Skip this Step>></button> -->
          </div>
          <!-- step 3 closed -->
 
          <!-- step 4 open -->
          <div class="SLV2-goalsttng-step" [ngClass]="[currentStep == 4 ? 'active' : '',  previousStep == 4 ? 'fixedtotop' : '']">
             <div class="SLV2-goalsttng-form-row targetcollege">
                <div class="SLV2-goalsttng-form-hdng-row">
                   <h4 class="SLV2-goalsttng-form-hdng">My target college(s) are</h4>
                   <h4 class="SLV2-goalsttng-form-subhdng">Select one or multiple colleges</h4>
                </div>
 
                <div class="SLV2-goalsttng-form-field-row">
                   <ul class="SLV2-input-list">
                     <ng-container *ngFor="let college of questionsData[3].data ">
                        <li>
                           <label class="SLV2-customcheck-input"><input type="checkbox" name="targetcollege" (change)="onCollegeSelect($event,college)" [checked]="isCollegeSelected(college)"/><span>{{college.collegeName}}</span></label>
                        </li>
                     </ng-container>
                   </ul>
                </div>
                <button class="SLV2-submit-btn" (click)="nextGoatStep()" [disabled]="userSelectedColleges?.length <=0">
                   <span>OK</span>
                   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                      <path d="M6.55156 13.0001L0.851562 7.3001L2.27656 5.8751L6.55156 10.1501L15.7266 0.975098L17.1516 2.4001L6.55156 13.0001Z" fill="#FCFCFC"/>
                      </svg>
                </button>
             </div>
             <!-- <button class="SLV2-skip-text-button" (click)="nextGoatStep()">Skip this Step>></button> -->
          </div>
          <!-- step 4 closed -->
 
          <!-- step 5 open -->
          <!-- <div class="SLV2-goalsttng-step" [ngClass]="[currentStep == 5 ? 'active' : '',  previousStep == 5 ? 'fixedtotop' : '']">
             <div class="SLV2-goalsttng-form-row targetbranch">
                <div class="SLV2-goalsttng-form-hdng-row">
                   <h4 class="SLV2-goalsttng-form-hdng">My target Branch</h4>
                   <h4 class="SLV2-goalsttng-form-subhdng">Select one or multiple colleges</h4>
                </div>
 
                <div class="SLV2-goalsttng-form-field-row">
                   <ul class="SLV2-input-list">
                      <li>
                         <label class="SLV2-customcheck-input"><input type="checkbox" name="targetbranch" /><span>Civil Engineering</span></label>
                      </li>
                      <li>
                         <label class="SLV2-customcheck-input"><input type="checkbox" name="targetbranch" /><span>Chemical Engineering</span></label>
                      </li>
                      <li>
                         <label class="SLV2-customcheck-input"><input type="checkbox" name="targetbranch" /><span>Computer Science & Engineering</span></label>
                      </li>
                      <li>
                         <label class="SLV2-customcheck-input"><input type="checkbox" name="targetbranch" /><span>Mechanical Engineering</span></label>
                      </li>
                      <li>
                         <label class="SLV2-customcheck-input"><input type="checkbox" name="targetbranch" /><span>Production Engineering</span></label>
                      </li>
                      <li>
                         <label class="SLV2-customcheck-input"><input type="checkbox" name="targetbranch" /><span>Electronics & Communication Engineering</span></label>
                      </li>
                   </ul>
                </div>
                <button class="SLV2-submit-btn" (click)="nextGoatStep()">
                   <span>OK</span>
                   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                      <path d="M6.55156 13.0001L0.851562 7.3001L2.27656 5.8751L6.55156 10.1501L15.7266 0.975098L17.1516 2.4001L6.55156 13.0001Z" fill="#FCFCFC"/>
                      </svg>
                </button>
             </div>
             <button class="SLV2-skip-text-button" (click)="nextGoatStep()">Skip this Step>></button>
          </div> -->
          <!-- step 5 closed -->
 
          <!-- step 6 open -->
          <div class="SLV2-goalsttng-step rank" [ngClass]="[currentStep == 5 ? 'active' : '',  previousStep == 5 ? 'fixedtotop' : '']">
             <div class="SLV2-goalsttng-form-row rank">
                <div class="SLV2-goalsttng-form-hdng-row">
                   <h4 class="SLV2-goalsttng-form-hdng">I want to get{{targetExamName == 'NEET' ? ' marks' : ' rank under'}}  </h4>
                   <h4 class="SLV2-goalsttng-form-subhdng">Select {{targetExamName == 'NEET' ? ' marks' : ' rank range'}}   </h4>
                </div>
                <div class="SLV2-goalsttng-slider-row" [ngClass]="[targetExamName == 'NEET' ? 'SLV2-goalsttng-slider-neet-row' : '']">
                   <mat-slider
                      class="SLV2-goalsttng-range-slider"
                      [disabled]="disabled"
                      [invert]="invert"
                      [max]="maxRank"
                      [min]="min"
                      [step]="step"
                      [thumbLabel]="thumbLabel"
                      [tickInterval]="tickInterval"
                      [(ngModel)]="value"
                      [vertical]="vertical"
                      (change)="onRankInputChange($event)">
                   </mat-slider>
                   <div class="SLV2-slider-steps" *ngIf="rankDividerValues">
                      <span>1</span>
                      <!-- <span>{{rankDividerValues[0]+rankDividerValues[1]}}</span> -->
                      <ng-container *ngIf="targetExamName == 'NEET'">
                        <span>{{(maxRank * 29.9) / 100  | number: '1.0-0'}}</span>
                        <span>{{(maxRank * 64) / 100 | number: '1.0-0'}}</span>
                     </ng-container>
                      <ng-container *ngIf="targetExamName != 'NEET'">
                        <span>{{(maxRank * 27) / 100}}</span>
                        <span>{{(maxRank * 60) / 100}}</span>
                     </ng-container>
                      <!-- <span>{{rankDividerValues[0]+rankDividerValues[1]+rankDividerValues[2]}}</span> -->
                      <span>{{maxRank}}</span>
                   </div>
                </div>
                <button class="SLV2-submit-btn" (click)="nextGoatStep()" [disabled]="value<=1">
                   <span>OK</span>
                   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                      <path d="M6.55156 13.0001L0.851562 7.3001L2.27656 5.8751L6.55156 10.1501L15.7266 0.975098L17.1516 2.4001L6.55156 13.0001Z" fill="#FCFCFC"/>
                      </svg>
                </button>
                <div class="SLV2-target-note" *ngIf="targetExamName != 'NEET'">
                   <div class="icn-holder"><img src="goal-setting-ui/assets/img/goal-setting/target-animated-icon.gif"/></div>
                   <span><b>Score {{minMaxScroreForRank?.minMarks}}+</b> marks in {{userSelectedExam?.value}} to achieve rank Under {{value}}</span>
                </div>
             </div>
          </div>
          <!-- step 6 closed -->
 
          <!-- step 7 open -->
          <div class="SLV2-goalsttng-step" [ngClass]="[currentStep == 6 ? 'active' : '',  previousStep == 6 ? 'fixedtotop' : '']">
             <div class="SLV2-goalsttng-form-row cgpa">
                <div class="SLV2-goalsttng-form-hdng-row">
                   <h4 class="SLV2-goalsttng-form-hdng">My marks in grade {{userSelectedGrade?.name=="9th" || userSelectedGrade?.name=="10th" ? userSelectedGrade?.name=="10th" ? "9th" : '8th' : userSelectedGrade?.name=="13th" ? '12th' : '10th'}} was</h4>
                   <h4 class="SLV2-goalsttng-form-subhdng">Enter CGPA or Percentage</h4>
                </div>
                <div class="SLV2-cgpa-row">
                   <div class="SLV2-cgpa-box">
                      <input type="text"  #grade10Input [placeholder]=" isTenthPercentage ? userSelectedGrade?.name=='9th' || userSelectedGrade?.name=='10th' ?userSelectedGrade?.name=='10th' ? '9th %' : '8th %' : '10th %' : userSelectedGrade?.name=='9th' || userSelectedGrade?.name=='10th' ?userSelectedGrade?.name=='10th' ? '9th CGPA' : '8th CGPA' :'10th CGPA'" [(ngModel)]="userEntered10Grade" [min]="0" [max]="isTenthPercentage ? 100 :10"   (input)="onkeyPress($event)" onkeypress="return !(event.charCode != 46 && event.charCode > 31  && (event.charCode < 48 || event.charCode > 57))"  onlyNumber/>
                      <div class="SLV2-cgpa-radio-grp">
                         <label><input type="radio" name="cgpa" [checked]="!isTenthPercentage" (change)="isTenthPercentage = !isTenthPercentage;userEntered10Grade=''"/><span>CGPA</span></label>
                         <label><input type="radio" name="cgpa" [checked]="isTenthPercentage" (change)="isTenthPercentage = !isTenthPercentage;userEntered10Grade=''"/><span>%</span></label>
                      </div>
                   </div>
                   <div class="SLV2-goalsttng-otp-actn-row" *ngIf="marksError">
                     <span class="SLV2-goalsttng-otp-text red">{{marksError}}</span>
                   </div>
                   <div class="SLV2-cgpa-box" *ngIf="userSelectedGrade?.name=='13th'">
                      <input type="text" value="" [placeholder]=" is12Percentage ? '12th %' :'12th CGPA'" [(ngModel)]="userEntered12Grade" [min]="0" [max]="is12Percentage ? 100 :10"  (input)="onkeyPressGrade12($event)"  onkeypress="return !(event.charCode != 46 && event.charCode > 31  && (event.charCode < 48 || event.charCode > 57))" onlyNumber/>
                      <div class="SLV2-cgpa-radio-grp">
                         <label><input type="radio" name="cgpa12" [checked]="!is12Percentage" (change)="is12Percentage = !is12Percentage;userEntered12Grade=''"/><span>CGPA</span></label>
                         <label><input type="radio" name="cgpa12" [checked]="is12Percentage" (change)="is12Percentage = !is12Percentage;userEntered12Grade=''"/><span>%</span></label>
                      </div>

                   </div>
                   <div class="SLV2-goalsttng-otp-actn-row" *ngIf="grade13Markserror">
                     <span class="SLV2-goalsttng-otp-text red">{{grade13Markserror}}</span>
                   </div>

                </div>
                
                <button class="SLV2-submit-btn" (click)="registerPopup()" [disabled]="userSelectedGrade?.name=='13th' ? !userEntered10Grade || !userEntered12Grade : !userEntered10Grade">
                   <span>Done</span>
                   <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
                      <path d="M6.55156 13.0001L0.851562 7.3001L2.27656 5.8751L6.55156 10.1501L15.7266 0.975098L17.1516 2.4001L6.55156 13.0001Z" fill="#FCFCFC"/>
                      </svg>
                </button>
 
 
             </div>
          </div>
          <!-- step 7 closed -->
 
 
          <!-- step action section open -->
          <div class="SLV2-goalsttng-step-actn-row">
             <div class="SLV2-goalsttng-actn-left SLV2-actnrow-btn-group" (click)="navigateToHome()">
                <button class="SLV2-actnrow-btn close-btn" ><img src="goal-setting-ui/assets/img/goal-setting/close-icon.svg" />Close</button>
             </div>
             <div class="SLV2-goalsttng-actn-right SLV2-actnrow-btn-group">
                <button class="SLV2-actnrow-btn prev-btn" (click)="prevGoatStep()" [disabled]="currentStep==1"><img src="goal-setting-ui/assets/img/goal-setting/arrow-down-gray-icon.svg" /><span>Previous</span></button>
                <ng-container *ngIf="currentStep < 6">
                   <button class="SLV2-actnrow-btn next-btn" (click)="nextGoatStep()" [disabled]="isNextButtonDisabled() || currentStep==6"><img src="goal-setting-ui/assets/img/goal-setting/arrow-down-gray-icon.svg" /><span>Next</span></button>
                </ng-container>
                <ng-container *ngIf="currentStep == 6">
                   <button class="SLV2-actnrow-btn next-btn" (click)="registerPopup()"  [disabled]="userSelectedGrade?.name=='13th' ? !userEntered10Grade || !userEntered12Grade : !userEntered10Grade"><img src="goal-setting-ui/assets/img/goal-setting/arrow-down-gray-icon.svg" /><span>Done</span></button>
                </ng-container>
             </div>
             
          </div>
          <!-- step action section closed -->
 
 
       </div>
 
 
    </div>
 </div>
 
 
 
 
 <!-- register now popup start -->
 <div class="SLV2-goal-register-popup-wrap" [ngClass]="{'show':registerPopupStatus}" >
    <div class="SLV2-goal-register-popup-box" [ngClass]="{'show':registerPopupInnerStatus}">
       <button class="SLV2-close-icon-button" (click)="registerPopupClose()"><img src="goal-setting-ui/assets/img/goal-setting/close-icon.svg" /></button>
       <div class="SLV2-register-popup-wrap">
          <div class="SLV2-goalsttng-form-row">
             <div class="SLV2-goalsttng-form-hdng-row">
                <h4 class="SLV2-goalsttng-form-hdng">Register Now</h4>
                <h4 class="SLV2-goalsttng-form-subhdng">You are 2 steps away from starting your learning journey</h4>
             </div>
 
             <div class="SLV2-goalsttng-form-field-group">
 
                <div class="SLV2-goalsttng-form-field-row">
                   <img src="goal-setting-ui/assets/img/goal-setting/profile-icon.svg" class="SLV2-form-field-icon" />
                   <input #firstNameInputId  type="text" class="SLV2-goalsttng-form-field" placeholder="First Name" [(ngModel)]="firstName" />
                </div>
 
                <div class="SLV2-goalsttng-form-field-row">
                   <img src="goal-setting-ui/assets/img/goal-setting/profile-icon.svg" class="SLV2-form-field-icon" />
                   <input type="text"  class="SLV2-goalsttng-form-field" placeholder="Last Name" [(ngModel)]="lasttName"/>
                </div>
                
                <!-- <div class="SLV2-goalsttng-form-field-row">
                   <img src="goal-setting-ui/assets/img/goal-setting/document-icon.png" class="SLV2-form-field-icon" />
                   <mat-form-field class="SLV2-grade-dropdown">
                      <mat-select panelClass="gradeDropdownList _right" placeholder="Grade" [(ngModel)]="userSelectedGrade.name">                   
                         <mat-option value="userSelectedGrade?.name" [value]="userSelectedGrade?.name">{{userSelectedGrade?.name}}</mat-option>
                          <mat-option value="2">10th</mat-option>
                         <mat-option value="3">11th</mat-option>
                         <mat-option value="4">12th</mat-option>
                         <mat-option value="5">13th</mat-option> 
                      </mat-select>
                   </mat-form-field>
                </div> -->
 
                <div class="SLV2-goalsttng-form-field-row">
                   <img src="goal-setting-ui/assets/img/goal-setting/phone-icon.svg" class="SLV2-form-field-icon phone" />
                   <div class="SLV2-goalsttng-form-phone-box">
                      <select><option value="+91">+91</option></select>
                      <input type="text" class="SLV2-goalsttng-form-field" placeholder="Phone Number" [(ngModel)]="phoneNumber"  maxlength='10'
                       onkeypress="return event.charCode>= 48 && event.charCode<=57" onlyNumber/>
                   </div>
                </div>
                <div class="SLV2-goalsttng-otp-actn-row SLV2-goalsttng-otp-error" *ngIf="phoneNumberError">
                  <span class="SLV2-goalsttng-otp-text red">{{phoneNumberError}}</span>
                </div>
 
                <div class="SLV2-goalsttng-form-field-row" *ngIf="!otpStatus">
                   <button class="SLV2-submit-btn full-width" (click)="otpSend()" [disabled]="(!firstName) || (!lasttName) ||(!(phoneNumber?.length >9))"><span>Get OTP</span></button>
                </div>
 
                <div class="SLV2-goalsttng-otp-area" [ngClass]="{'show':otpStatus}">
                   <div class="SLV2-goalsttng-otp-box">
                      <span>Enter OTP</span>
                      <ng-otp-input (onInputChange)="onOtpChange($event)" id="otpboxes" [config]="config"></ng-otp-input>
                   </div>
                   <span class="SLV2-goalsttng-otp-text red" *ngIf="errorMessage">{{errorMessage}}</span>
                   <!-- <div class="SLV2-goalsttng-otp-actn-row SLV2-goalsttng-otp-error" *ngIf="errorMessage">
                     <span class="SLV2-goalsttng-otp-text red">{{errorMessage}}</span>
                   </div> -->
                   <div class="SLV2-goalsttng-otp-actn-row">
                      <span class="SLV2-goalsttng-otp-text green">{{timer>45 && timer!=60? 'OTP Sent': ''}}</span>
                      <button class="SLV2-goalsttng-otp-text purple" [disabled]="timer!=60" (click)=" verifyPhone()">Resend OTP {{timer>0 && timer!=60 ? 'in '+timer: ''}} </button>
                   </div>
                   <button class="SLV2-submit-btn full-width" (click)="valiDateOtp()" [disabled]="!(userEnteredOtp?.length >=4) || !isTermsAndConditionsSelected"><span>Continue</span></button>
                </div>
 
                <div class="SLV2-custom-check-group">
                   <label class="SLV2-custom-check">
                      <input type="checkbox" [checked]="isTermsAndConditionsSelected" (change)="isTermsAndConditionsSelected=!isTermsAndConditionsSelected" /><span>By signing up you agree to our <a target="_blank"  style="cursor:pointer" href="https://terms.infinitylearn.com/">T&C</a>  and <a target="_blank"   style="cursor:pointer" href="https://privacy.infinitylearn.com/">Privacy Policy</a> </span>
                   </label>
                   <label class="SLV2-custom-check">
                      <input type="checkbox" [checked]="isWhatsUpConsentChecked" (change)=" isWhatsUpConsentChecked =!isWhatsUpConsentChecked"/><span>Receive updates on Whatsapp</span>
                   </label>
                </div>
 
             </div>
          </div>
       </div>
    </div>
    <div class="SLV2-goal-register-popup-bg" [ngClass]="{'show':registerPopupInnerStatus}"></div>
 </div>
 <!-- register now popup ended -->
 
 
 <!-- register success start -->
 <div class="SLV2-registration-success-wrap" [ngClass]="{'show':registrationLoadingStatus}">
 
    <div class="SLV2-registration-success-loading step-1" [ngClass]="{'show':registrationSuccess_Step1}">
       <img src="goal-setting-ui/assets/img/goal-setting/success-loading.gif" class="loading-step-1-gif" />
       <span>Please wait we are personalising your<br> journey</span>
    </div>
 
    <div class="SLV2-registration-success-loading step-2" [ngClass]="{'show':registrationSuccess_Step2}">
       <div class="SLV2-rgstr-step-content" [ngClass]="{'with-3rd-success':registrationSuccess_Step3}">
          <div class="SLV2-rgstr-step-top-row">
             <img src="goal-setting-ui/assets/img/goal-setting/success-animated-icon.gif" class="loading-step-2-gif" />
             <span>Congratulations on setting your goals</span>
          </div>
          <div class="SLV2-rgstr-step-bottom-row">
             <div class="SLV2-rgstr-step-bottom-cnt">
                <div class="SLV2-goalsttng-form-row">
                   <div class="SLV2-goalsttng-form-hdng-row">
                      <h4 class="SLV2-goalsttng-form-hdng">We have created the curriculum for you</h4>
                      <h4 class="SLV2-goalsttng-form-subhdng">Choose a subject to start</h4>
                   </div>
                   <div class="SLV2-goalsttng-form-field-row">
                      <ul class="SLV2-input-list">
                         <li *ngFor="let subject of userSubjects" (click)="changeSelectedSubject(subject)">
                            <label class="SLV2-customcheck-input subject {{subject.nodeName}}"><input type="radio" name="subject" /><div class="wrap"><div class="icon-holder"><img [src]="subject.icon" /></div>{{subject.nodeName}}</div></label>
                         </li>
                      </ul>
                   </div>
                   <div class="SLV2-step-action-row">
                      <button class="SLV2-submit-btn" (click)="goToSubjectPage(selectedSubject)" [disabled]="!selectedSubject"><span>Let’s Learn</span> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16" fill="none"><path d="M24.7071 8.70711C25.0976 8.31658 25.0976 7.68342 24.7071 7.29289L18.3431 0.928932C17.9526 0.538408 17.3195 0.538408 16.9289 0.928932C16.5384 1.31946 16.5384 1.95262 16.9289 2.34315L22.5858 8L16.9289 13.6569C16.5384 14.0474 16.5384 14.6805 16.9289 15.0711C17.3195 15.4616 17.9526 15.4616 18.3431 15.0711L24.7071 8.70711ZM0 9H24V7H0V9Z" fill="#FCFCFC"/></svg></button>
                      <button class="SLV2-submit-btn normal" (click)="navigateToHome()"><span>I’ll do it later</span></button>
                   </div>
                   
                </div>
             </div>
             
          </div>
       </div>
    </div>
 </div>
 <!-- register success ended -->
 
 
 
 
 
 
 <ng-template #slider_1>
    <!-- slider 1 open -->
    <ng-container *ngIf="getSelectedGrade < 11 || (getSelectedGrade == 0)">
      <div class="SLV2-goalsttng-sldr mobile-active slider-1" [ngClass]="[currentStep == 1 ? 'active':'']">
         <div class="SLV2-goalsttng-sldr-content">
            <h5 class="SLV2-goalsttng-sldr-hdr">Ready, Set, Excel!</h5>
            <span>Step closer to your ultimate goal of <br>cracking JEE/NEET by mapping your <br>learning journey.</span>
         </div>
         <img src="goal-setting-ui/assets/img/goal-setting/step-1-home.svg" class="SLV2-gs-slider-home" />
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-1-img-1.svg" class="SLV2-gs-slider-1-1-img" />
         <img src="goal-setting-ui/assets/img/goal-setting/slider-1-mobile-img.svg" class="SLV2-gs-slider-mobile-img" />
      </div>
    </ng-container>
    <ng-container *ngIf="getSelectedGrade > 10">
      <div class="SLV2-goalsttng-sldr mobile-active slider-1" [ngClass]="[currentStep >= 1 && currentStep < 4 ? 'active':'']">
         <div class="SLV2-goalsttng-sldr-content">
            <h5 class="SLV2-goalsttng-sldr-hdr">Ready, Set, Excel!</h5>
            <span>Step closer to your ultimate goal of <br>cracking JEE/NEET by mapping your <br>learning journey.</span>
         </div>
         <img src="goal-setting-ui/assets/img/goal-setting/step-1-home.svg" class="SLV2-gs-slider-home" />
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-1-img-1.svg" class="SLV2-gs-slider-1-1-img" />
         <img src="goal-setting-ui/assets/img/goal-setting/slider-1-mobile-img.svg" class="SLV2-gs-slider-mobile-img" />
      </div>
    </ng-container>
    <!-- slider 1 closed -->
   </ng-template>
 
   <ng-template #slider_2>
    <!-- slider 2 open -->
    <ng-container *ngIf="getSelectedGrade < 11">
      <div class="SLV2-goalsttng-sldr mobile-active slider-2" [ngClass]="[currentStep == 2 ? 'active':'']">
         <div class="SLV2-goalsttng-sldr-content">
            <h5 class="SLV2-goalsttng-sldr-hdr">Buckle up, Future Achievers!</h5>
            <span>Define your desired rank and target <br>colleges like top IITs/NITs/AIIMS etc.</span>
         </div>
         <img src="goal-setting-ui/assets/img/goal-setting/Isolation_Mode.svg" class="SLV2-gs-slider-2-1-img" />
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-2-hand.svg" class="SLV2-gs-slider-2-hand-img" />
      </div>
    </ng-container>
    <ng-container *ngIf="getSelectedGrade > 10">
      <div class="SLV2-goalsttng-sldr mobile-active slider-2" [ngClass]="[currentStep >= 4 && currentStep < 5 ? 'active':'']">
         <div class="SLV2-goalsttng-sldr-content">
            <h5 class="SLV2-goalsttng-sldr-hdr">Buckle up, Future Achievers!</h5>
            <span>Define your desired rank and target <br>colleges like top IITs/NITs/AIIMS etc.</span>
         </div>
         <img src="goal-setting-ui/assets/img/goal-setting/Isolation_Mode.svg" class="SLV2-gs-slider-2-1-img" />
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-2-hand.svg" class="SLV2-gs-slider-2-hand-img" />
      </div>
    </ng-container>
    <!-- slider 2 closed -->
 </ng-template>
 
 <ng-template #slider_3>
    <!-- slider 3 open -->
    <ng-container *ngIf="getSelectedGrade < 11">
      <div class="SLV2-goalsttng-sldr mobile-active slider-3" [ngClass]="[currentStep == 5 || currentStep == 6 ? 'active':'', currentStep == 7 ? 'stopanimate':'']">
         <div class="SLV2-goalsttng-sldr-content">
            <h5 class="SLV2-goalsttng-sldr-hdr">Get on the Road to Success!</h5>
            <span>Let our experts design a personalised <br>learning jounery to ensure your admission</span>
         </div>
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-3-home.svg" class="SLV2-gs-slider-3-home" />
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-3-road.svg" class="SLV2-gs-slider-3-road" />
         <img src="goal-setting-ui/assets/img/goal-setting/slider-3-mobile-img.svg" class="SLV2-gs-slider-mobile-img" />
      </div>
    </ng-container>
    <ng-container *ngIf="getSelectedGrade > 10">
      <div class="SLV2-goalsttng-sldr mobile-active slider-3" [ngClass]="[currentStep >= 5 && currentStep < 7 ? 'active':'', currentStep == 7 ? 'stopanimate':'']">
         <div class="SLV2-goalsttng-sldr-content">
            <h5 class="SLV2-goalsttng-sldr-hdr">Get on the Road to Success!</h5>
            <span>Let our experts design a personalised <br>learning jounery to ensure your admission</span>
         </div>
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-3-home.svg" class="SLV2-gs-slider-3-home" />
         <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-3-road.svg" class="SLV2-gs-slider-3-road" />
         <img src="goal-setting-ui/assets/img/goal-setting/slider-3-mobile-img.svg" class="SLV2-gs-slider-mobile-img" />
      </div>
    </ng-container>
    <!-- slider 3 closed -->
 </ng-template>
 <ng-template #slider_4>
    <!-- slider 4 open -->
    <div class="SLV2-goalsttng-sldr mobile-active slider-4" [ngClass]="[currentStep == 7 ? 'active':'']">
       <div class="SLV2-goalsttng-sldr-content">
          <h5 class="SLV2-goalsttng-sldr-hdr">Get on the Road to Success!</h5>
          <span>Let our experts design a personalised <br>learning jounery to ensure your admission</span>
       </div>
       <img src="goal-setting-ui/assets/img/goal-setting/goal-setting-slider-4-full.svg" class="SLV2-gs-slider-4-road" />
       <img src="goal-setting-ui/assets/img/goal-setting/slider-4-mobile-img.svg" class="SLV2-gs-slider-mobile-img" />
    </div>
    <!-- slider 4 closed -->
 </ng-template>
